import React from 'react';
import { Chip } from '@mui/material';
import { HiDocumentText, HiTrash } from 'react-icons/hi2';
import { FiBookmark } from 'react-icons/fi';
import './AssessmentCreditCard.css';

// Card component for displaying papers available for direct purchase
// Note: Displays hardcoded placeholder values - API data structure is ready for integration
const AssessmentCreditCard = ({ assessment, onRemove, onSave, userType }) => {
    const totalPrice = assessment.price;
    return (
        <div className="assess-credit-card">
            <div className="assess-credit-content">
                <div className="assess-credit-icon-wrapper">
                    <HiDocumentText className="assess-credit-icon" />
                </div>

                {/* Title + credits count stacked */}
                <div className="assess-credit-details">
                    <h4 className="assess-credit-title">{assessment.title}</h4>
                    {userType === "parent" && assessment.user_code && (
                        <p className="assess-credit-subtitle">For Student: {assessment.user_code}</p>
                    )}
                    {/* <p className="assess-credit-subtitle">{assessment.credits} Credit(s)</p> */}
                </div>

                {/* Quantity Stepper */}
                <div className="assess-credit-qty">
                    <span className="qty-value">1</span>
                </div>

                {/* Total price chip */}
                <Chip
                    label={`${totalPrice.toFixed(2)} ${assessment.currencySymbol}`}
                    size="small"
                    className="assess-credit-price-chip"
                />

                <div className="assess-credit-actions">
                    <button
                        onClick={onSave}
                        className="assess-credit-save-btn"
                        aria-label="Save item"
                    >
                        <FiBookmark />
                    </button>

                    <button
                        onClick={onRemove}
                        className="assess-credit-remove-btn"
                        aria-label="Remove item"
                    >
                        <HiTrash />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssessmentCreditCard;
